const LEGACY_BASE_URL =
  import.meta.env.VITE_LEGACY_API_URL || 'https://sistema.bsports.cl/index.php?r=';

export interface LegacyLoginResult {
  idUsuario: number;
  token: string;
  nomUsuario?: string;
  apePatUsuario?: string;
  email?: string;
}

interface LegacyLoginResponse {
  status: number;
  messaje: string;
  result:
    | {
        idUsuario: number;
        token: string;
        nomUsuario?: string;
        apePatUsuario?: string;
        [key: string]: unknown;
      }
    | '';
}

export class LegacyAccountError extends Error {
  status: number;

  constructor(message: string, status = -1) {
    super(message);
    this.name = 'LegacyAccountError';
    this.status = status;
  }
}

async function postJson<T>(action: string, body: unknown): Promise<T> {
  const res = await fetch(`${LEGACY_BASE_URL}${action}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    throw new LegacyAccountError(`HTTP ${res.status}`, res.status);
  }

  const text = await res.text();
  try {
    return JSON.parse(text) as T;
  } catch {
    // Some legacy endpoints return a plain scalar (e.g. "1" / "0")
    return text.trim() as unknown as T;
  }
}

export const legacyAccountService = {
  /**
   * Authenticates against the legacy backend (site/LoginApp).
   * Returns the idUsuario + token required to disable the account.
   */
  async login(email: string, clave: string): Promise<LegacyLoginResult> {
    const data = await postJson<LegacyLoginResponse>('site/LoginApp', {
      email: email.trim(),
      clave,
      devToken: '',
    });

    if (data.status !== 0 || !data.result) {
      throw new LegacyAccountError(data.messaje || 'Login incorrecto', data.status);
    }

    return {
      idUsuario: Number(data.result.idUsuario),
      token: String(data.result.token),
      nomUsuario: data.result.nomUsuario as string | undefined,
      apePatUsuario: data.result.apePatUsuario as string | undefined,
      email: email.trim(),
    };
  },

  /**
   * Disables / soft-deletes the account (usuario/DeshabilitarUser).
   * Mirrors the legacy Flutter app behaviour: email is suffixed with
   * "-deleted" and estado is set to 0. Returns true on success.
   */
  async deleteAccount(idUsuario: number, token: string): Promise<boolean> {
    const result = await postJson<string | number>('usuario/DeshabilitarUser', {
      idUsuario,
      token,
    });

    return String(result).trim() === '1';
  },
};

export default legacyAccountService;
